import { APPLICATION_ORIGIN_CODES, APPLICATION_ORIGIN_LABELS } from '@profilpublic/api-contract/application'

export function buildMotivationAnswers(formValues, questions) {
  if (!formValues) return undefined

  const answers = questions
    .map((question, index) => ({
      question,
      answer: formValues[`motivationQuestion${index + 1}`] || ''
    }))
    .filter(item => item.answer)

  return answers.length ? answers : undefined
}

export function extractOriginFromQuery(query) {
  const { o: origin, xsource } = query
  if (origin === 'xm') return xsource?.toLowerCase() ?? null
  const custom = typeof origin === 'string' && origin.trim() ? origin.trim().toLowerCase().slice(0, 100) : null
  return APPLICATION_ORIGIN_CODES[origin?.replace('talent', 'ta')] ?? custom ?? null
}

export function getApplicationFullName(application, capitalize = true, shorten = false) {
  return getFullName(
    {
      firstName: application?.firstName ?? application?.candidate?.firstName,
      lastName: application?.lastName ?? application?.candidate?.lastName
    },
    capitalize,
    shorten
  )
}

export function getPrettyApplicationOrigin(origin, trackerNames = null) {
  return APPLICATION_ORIGIN_LABELS[origin] || trackerNames?.[origin] || origin
}
